import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileActionBar } from "@/components/layout/MobileActionBar";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
    <ScrollToTop />
    <Header />
    <main className="min-h-screen pb-16 xl:pb-0">
      <Outlet />
    </main>
    <Footer />
    <MobileActionBar />
  </ReactLenis>
);
